<template>
  <a-cascader v-model="val" :options="options" style="width: 100%" placeholder="请选择数据类型" @change="onChange" />
</template>

<script>
import { querySpiderClassInfoApi } from '@/api/Site/Type'
export default {
  data() {
    return {
      options: [],
      val: []
    }
  },
  props: ['value'],
  created() {
    this.querySpiderClassInfoApi()
  },
  methods: {
    onChange(value) {
      this.$emit('input', value)
    },
    async querySpiderClassInfoApi() {
      let res = await querySpiderClassInfoApi()
      let { code, msg, data } = res
      if (code == '200') {
        if (Array.isArray(data)) {
          data.forEach((item) => {
            if (item.type == 'toutiao') {
              this.options.push({
                value: item.type,
                label: item.spiderClassName,
                children: [
                  {
                    value: 'toutiao_article',
                    label: '头条文章 '
                  },
                  {
                    value: 'toutiao_person',
                    label: '微头条 '
                  }
                ]
              })
            } else {
              this.options.push({
                value: item.type,
                label: item.spiderClassName
              })
            }
          })
        }
      } else {
        this.$message.error(msg)
      }
    }
  },
  watch: {
    value: {
      handler() {
        this.val = this.value
      },
      immediate: true
    }
  }
}
</script>

<style lang="less" scoped></style>
